import React from 'react'

const FCeboAdjustmentPartial = () => {
    return (
        <p>No FC<sub>(elec + boiler + other)</sub> adjustments are available for this vessel</p>
    )
}

export default FCeboAdjustmentPartial